import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal
} from '@angular/core';
import { take } from 'rxjs';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { AuthStore } from '@core/services/auth/auth.store';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'vex-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatRippleModule, MatIconModule, TranslatePipe]
})
export class ToolbarUserComponent {
  private readonly popover = inject(VexPopoverService);
  private readonly authStore = inject(AuthStore);

  readonly user = this.authStore.user;
  readonly dropdownOpen = signal(false);

  readonly userName = computed(() => {
    const u = this.user();
    if (!u) return 'User';
    if (u.firstName && u.lastName) return `${u.firstName} ${u.lastName}`;
    if (u.firstName) return u.firstName;
    if (u.email) return u.email.split('@')[0];
    return 'User';
  });

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen.set(true);

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });

    popoverRef.afterClosed$.pipe(take(1)).subscribe(() => {
      this.dropdownOpen.set(false);
    });
  }
}
